import React from 'react';
import { connect } from 'react-redux'

import { Row, Col, Divider, List, Spin, Dropdown, Button, Empty, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, DownCircleOutlined, DownloadOutlined, EditOutlined, FileDoneOutlined, FileSyncOutlined, IssuesCloseOutlined, SendOutlined, UploadOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';

const statusLabels = {
  "Draft": "yellow",
  "Diajukan": "",
  "Disetujui": "blue",
  "Ditolak": "red",
  "Dibatalkan": "red",
  "Selesai": "green",
}

const statusIcons = {
  "Draft": <FileSyncOutlined />,
  "Diajukan": <SendOutlined style={{ transform: "rotate(-30deg)" }} />,
  "Disetujui": <CheckCircleOutlined />,
  "Ditolak": <CloseCircleOutlined />,
  "Dibatalkan": <IssuesCloseOutlined />,
  "Selesai": <FileDoneOutlined />,
}

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={
                table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)
              }
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      title={(row.gelar_depan ? row.gelar_depan + " " : "") + (row.tk_nama ? row.tk_nama : "-") + (row.gelar_belakang ? " " + row.gelar_belakang : "")}
                      description={<>
                        <Row gutter={[8, 8]}>
                          <Col xs={24}>
                            <small>
                              Tanggal: {row.tgl_awal} to {row.tgl_akhir} <br />
                              Ruangan: {row.ruangan_nama ? row.ruangan_nama : "-"} <br />
                              Gedung/Lahan: {row.lahan_nama ? row.lahan_nama : "-"},{row.gedung_nama ? row.gedung_nama : "-"} <br />
                              Status: <Tag color={statusLabels[row.status]} icon={statusIcons[row.status]}>{row.status}</Tag> <br />
                              Keterangan: {row.keterangan ? row.keterangan : "-"} <br />
                              Dokumentasi: {row.file ? <a target="_blank" rel="noopener noreferrer" download={true} href={row.main_path + row.file} style={{ fontSize: 11 }}>Download <DownloadOutlined /></a> : "-"}
                            </small>
                          </Col>
                        </Row>
                      </>}

                    />
                    <div>
                      {(row.status === "Diajukan" ? "-" : row.status === "Selesai" || row.status === "Dibatalkan" || row.status === "Ditolak" ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.update && row.status === "Draft" ? [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.request_approval && !action.approval && row.status === "Draft" ? [{
    key: 1,
    icon: <SendOutlined style={{
      transform: "rotate(-30deg)"
    }} />,
    label: "Minta Persetujuan",
    onClick: this.props.modalRequestApproval.bind(this, true, row)
  }] : []), ...(action.approval && row.status === "Diajukan" ? [{
    key: 2,
    icon: <CheckCircleOutlined />,
    label: "Setujui",
    onClick: this.props.modalApprove.bind(this, true, row)
  }] : []), ...(action.approval && row.status === "Diajukan" ? [{
    key: 3,
    icon: <CloseCircleOutlined />,
    label: "Tolak",
    onClick: this.props.modalReject.bind(this, true, row)
  }] : []), ...(action.approval && row.status === "Disetujui" ? [{
    key: 4,
    icon: <IssuesCloseOutlined />,
    label: "Batalkan",
    onClick: this.props.modalCancel.bind(this, true, row)
  }] : []), ...(action.request_approval && !action.approval && row.status === "Disetujui" ? [{
    key: 5,
    icon: <UploadOutlined />,
    label: "Upload Dokumentasi (Selesaikan)",
    onClick: this.props.modalUploadDocumentation.bind(this, true, row)
  }] : []), ...(action.delete && row.status === "Draft" ? [{
    key: 6,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : [])]
}}>
                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                      </Dropdown>)}
                    </div>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Mobile);
